import { SetStateAction, useCallback, useContext } from "react";

import { Customer } from "../../interfaces/Customer";

import { IndexerValueTypes } from "../../interfaces/IndexerValueTypes";

import { CustomerContext } from "./customer-context";
import { CustomerHookType } from "./customer-context.types";

export const useCustomer = (): CustomerHookType => {
  const { customer, setCustomer } = useContext(CustomerContext);

  const createCustomer = useCallback(
    (newCustomer: Customer): void => {
      setCustomer(newCustomer);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [customer]
  );

  const onChangeCustomer = useCallback(
    (key: string , newValue: IndexerValueTypes): void => {
      setCustomer({
        ...customer,

        [key]: newValue,
      } as SetStateAction<Customer | null>);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [customer]
  );

  const deleteCustomer = useCallback((): void => {
    setCustomer(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer]);

  return {
    customer,
    createCustomer,
    onChangeCustomer,
    deleteCustomer,
  };
};
